/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export default function Plus({ width = "18", height = "18" }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} viewBox="0 0 18 18" className="svg plus">
			<path d="M15.5,6.5h-4v-4a2.5,2.5,0,0,0-5,0v4h-4a2.5,2.5,0,0,0,0,5h4v4a2.5,2.5,0,0,0,5,0v-4h4a2.5,2.5,0,0,0,0-5Z" />
		</svg>
	);
}

Plus.propTypes = {
	width: PropTypes.string,
	height: PropTypes.string
};
